import { CollapsibleContentCard, LargeTitle, palettes, Status } from '@indigo-ag/component-module';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import React, { useContext } from 'react';
import { LoadingIndicator } from 'shared';
import styled from 'styled-components';
import i18next from 'i18next';
import { RiskClassificationCard } from '../../components/BackgroundCheck/RiskClassification/RiskClassificationCard';
import { ContactRiskClassificationItem } from '../Phase1.utils';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { NoContactsFound } from 'shared/components/NoResultsFound/NoContactsFounds';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface Props {
  riskClassificationList: ContactRiskClassificationItem[];
  loading?: boolean;
  readOnly?: boolean;
}

const getStatusLabel = (status: ContactRiskClassificationItem['status']) =>
  i18next.t(`preAnalysisRiskLevel-section-status-${status}`);

const MAP_STATUS_VARIANT = {
  PENDING: 'warning' as FeedbackVariants,
  SUCCESS: 'success' as FeedbackVariants,
  FAILURE: 'error' as FeedbackVariants
};

export const FundsApprovalSection = ({ riskClassificationList, loading, readOnly }: Props) => {
  const { agFinancingId } = useContext(FinanceProcessContext);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (!riskClassificationList?.length) {
    return <NoContactsFound />;
  }

  return (
    <>
      <LargeTitle style={{ marginBottom: '16px', color: palettes.brand.blue.base }}>
        {i18next.t('preAnalysisFunds')}
      </LargeTitle>
      <StyledContainer>
        {riskClassificationList.map(item => (
          <CollapsibleContentCard
            key={item.contactTaxIdentifier}
            titleText={item.contactName}
            renderAfterTitle={() => (
              <Status label={getStatusLabel(item.status)} variant={MAP_STATUS_VARIANT[item.status]} />
            )}
          >
            <RiskClassificationCard riskClassification={item} agFinancingId={agFinancingId} />
          </CollapsibleContentCard>
        ))}
      </StyledContainer>
    </>
  );
};
